import { checkTodayInRange } from '@/utils/checkTodayInRange';

const NONE_EVENT_PERIOD_DATE = '1970-01-01T00:00:00' as const;

/**
 * 친구초대 이벤트 키
 * ! 순서 중요
 */
export const INVITE_EVENT_KEY = {
  /** 11월 1차 친구초대 이벤트 */
  NOVEMBER_EVENT_FIRST: 'NOVEMBER_EVENT_FIRST',
  /** 11월 2차 친구초대 이벤트 */
  NOVEMBER_EVENT_SECOND: 'NOVEMBER_EVENT_SECOND',
  /** 12월 친구초대 이벤트 */
  DECEMBER_EVENT: 'DECEMBER_EVENT',
} as const;

/**
 * 친구초대 이벤트 기간
 */
const INVITE_EVENT_PERIOD = {
  [INVITE_EVENT_KEY.NOVEMBER_EVENT_FIRST]: {
    startDate: '2025-11-01T00:00:00',
    endDate: '2025-11-13T23:59:59',
  },
  [INVITE_EVENT_KEY.NOVEMBER_EVENT_SECOND]: {
    startDate: '2025-11-14T00:00:00',
    endDate: '2025-11-30T23:59:59',
  },
  [INVITE_EVENT_KEY.DECEMBER_EVENT]: {
    startDate: '2025-12-16T00:00:00',
    endDate: '2025-12-31T23:59:59',
  },
} as const satisfies Record<
  (typeof INVITE_EVENT_KEY)[keyof typeof INVITE_EVENT_KEY],
  { startDate: string; endDate: string }
>;

/**
 * 현재 진행중인 친구 초대 공통 설정
 */
export const INVITE_COMMON_CONFIG = {
  event: (() => {
    const currentEventKey = (() => {
      const found = Object.entries(INVITE_EVENT_PERIOD).find(([, value]) =>
        checkTodayInRange(value.startDate, value.endDate),
      );

      return found ? (found[0] as keyof typeof INVITE_EVENT_PERIOD) : null;
    })();

    return {
      startDate: currentEventKey
        ? INVITE_EVENT_PERIOD[currentEventKey].startDate
        : NONE_EVENT_PERIOD_DATE,
      endDate: currentEventKey
        ? INVITE_EVENT_PERIOD[currentEventKey].endDate
        : NONE_EVENT_PERIOD_DATE,
      eventKey: currentEventKey,
    };
  })(),
};
